import { connect } from 'react-redux';
import { TopBarButton } from './component';
import {
  updateTopBarExpendedMenu,
  updateTopBarButtonMenuTriggeredClick,
} from '../../../../ReduxStorage/TopBar/dispatchers';
import {
  selectTopBarIsMenuTriggeredClick,
  selectTopBarExpandedMenu,
} from '../../../../ReduxStorage/TopBar/selectors';

function mapStateToProps(state) {
  return {
    isExpandedMenuTriggeredClick: selectTopBarIsMenuTriggeredClick(state),
    expandedMenu: selectTopBarExpandedMenu(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateTopBarExpendedMenu: (args) =>
      dispatch(updateTopBarExpendedMenu(args)),
    updateTopBarButtonMenuTriggeredClick: (args) => {
      dispatch(updateTopBarButtonMenuTriggeredClick(args));
    },
  };
}

export const ConnectorTopBarButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(TopBarButton);
